export default __webpack_public_path__ + "static/media/Roboto.fc2b5060.ttf";